import { render, staticRenderFns } from "./PromocodeList.vue?vue&type=template&id=5df0db0e"
import script from "./PromocodeList.vue?vue&type=script&lang=js"
export * from "./PromocodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports